<template>
  <div class="jl-pay-wrap">
    <div class="jl-pay-bread">
      <div class="jl-container">
        <!-- <div class="pay-bread">
          <a>我的购物车 ></a>
          <a>订单详情 ></a>
          <a class="active">订单支付</a>
        </div>-->
      </div>
    </div>
    <div class="jl-pay-content">
      <div class="jl-container">
        <div class="pay-header">
          <div class="pay-header-info">
            <p class="text1">订单提交成功，请尽快支付！订单号：{{$route.params.id}}</p>
            <p class="text2">
              请您在
              <span class="text2-1">{{overtime}}小时内</span>完成支付，否则订单会被自动取消(库存紧俏订单请参见详情页时限)
            </p>
            <div class="pay-h-rbox">
              <!-- <p class="text1">
                应付金额：
                <span class="text1-1">¥</span>
                <span class="text1-2">{{orderPrice}}</span>
              </p>-->
              <p class="text2">
                <span
                  :class="[isShowDetail?'text2-2 active':'text2-2']"
                  @click="isShowDetail = !isShowDetail"
                >
                  订单详情
                  <i class="jl-icon-sanjiao_down"></i>
                </span>
              </p>
            </div>
          </div>
          <div class="order-detail" v-if="isShowDetail">
            <p class="text3">收货地址： {{addressText}}</p>
            <p class="text3">商品名称：{{shopNameText}}</p>
          </div>
        </div>
        <div class="pay-body">
          <div class="pay-body-box">
            <ul class="pay-body-list">
              <li class="item">
                <div class="box-info">
                  <p class="text alt-label">支付形式</p>
                  <div class="right-box">
                    <span :class="[payType === 0?'btn active':'btn']" @click="payType = 0">
                      <img src="../../assets/img/zkj-zfb.png" alt />
                      支付宝
                    </span>
                    <!-- <span :class="[payType === 1?'btn active':'btn']" @click="payType = 1">
                      <img src="../../assets/img/zkj-weix.png" alt />
                      微信
                    </span>-->
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="box-info">
                  <p class="text alt-label">支付对象</p>
                  <div class="right-box">
                    <p class="text1">荔虹锦鲤园</p>
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="box-info">
                  <p class="text alt-label">应付金额：</p>
                  <div class="right-box">
                    <p class="text1 alt-red">￥ {{orderPrice}}</p>
                  </div>
                </div>
              </li>
              <li class="item" v-if="isShowDj">
                <div class="box-info">
                  <p class="text alt-label">已付定金：</p>
                  <div class="right-box">
                    <p class="text1 alt-red">￥ 200</p>
                  </div>
                </div>
              </li>
              <li class="item">
                <div class="box-info">
                  <p class="text alt-label">实付金额：</p>
                  <div class="right-box">
                    <p class="text1 alt-red">￥ {{auctionInfo.waitPaidPrice}}</p>
                  </div>
                </div>
              </li>
            </ul>
            <div class="pay-submit">
              <button class="btn" @click="pay">
                立即支付
                <i class="el-icon-loading" v-if="isPayLoading"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="pay-modal" v-show="isShowPay">
      <div class="pay-modal-body" v-show="isShowPay">
        <div class="pay-body_box">
          <div class="pay-body_imgbox" v-if="payType !== 0">
            <canvas class="pay-body_canvas" id="canvas"></canvas>
          </div>
          <div class="pay-body_imgbox" v-else>
            <div v-html="payAlipayForm"></div>
          </div>
          <div class="pay-body_operat">
            <p class="pay-body_text">{{payType === 0?'支付宝':'微信'}}扫一扫二维码，进行支付</p>
            <el-button type="primary" @click="checkOrderPay">完成支付</el-button>
          </div>
        </div>
      </div>
      <div class="pay-shadow" v-show="isShowPay" @click="checkOrderPay"></div>
    </div>
  </div>
</template>

<script>
import QRCode from 'qrcode';
import { mapGetters } from 'vuex';
import {
  orderDetail,
  payWechart,
  payAlipay,
  checkOrderPay,
  overTime
} from '../../api/order';
export default {
  name: 'orderPay',
  data() {
    const orderId = this.$route.params.id;
    const returnUrl = window.location.href.split('#')[0] + '#/order/list';
    return {
      isShowDetail: false,
      payType: 0, //支付方式 0=>支付宝 1=>微信
      orderPrice: '',
      addressText: '',
      shopNameText: '',
      orderId: orderId,
      isShowPay: false,
      isDeposit: 0, //是否为押金 0 订单支付  1 押金支付,
      payAlipayForm: '', //支付宝支付表单
      returnUrl: returnUrl, //支付宝成功支付返回页面地址
      overtime: '', //逾期时间
      payPrice: '',
      auctionInfo: {},
      isShowDj: false,
      isPayLoading: false
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  created() {
    this.getOrderDetail();
    overTime(this);
  },
  methods: {
    getOrderDetail() {
      orderDetail(this);
    },
    pay() {
      //支付
      this.payPrice = this.auctionInfo.waitPaidPrice;
      this.isPayLoading = true;
      if (this.payType === 0) {
        //支付宝
        payAlipay(this, res => {
          if (res.code == 200) {
            this.$nextTick(() => {
              document.forms[0].submit();
            });
          }
        });
      } else {
        //微信
        payWechart(this, res => {
          if (res && res.code_url) {
            this.isShowPay = true;
            this.qrcodeFn(res.code_url);
          }
        });
      }
    },
    qrcodeFn(url) {
      QRCode.toCanvas(document.getElementById('canvas'), url, function(error) {
        if (error) console.error(error);
        console.log('success!');
      });
    },
    checkOrderPay() {
      checkOrderPay(this, bool => {
        this.isShowPay = false;
        document.body.className = '';
        if (bool) {
          this.$router.push({
            path: '/order/list'
          });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.jl-pay-wrap {
  padding-bottom: 133px;
}
.jl-container {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
}
.jl-pay-content {
  margin-top: 38px;
  .pay-header {
    margin-bottom: 30px;
    .pay-header-info {
      position: relative;
      padding-left: 70px;
      background: url('../../assets/img/zkj-order-success.png') no-repeat left
        top;
      .text1 {
        font-size: 18px;
        color: #333;
        line-height: 30px;
      }
      .text2 {
        font-size: 14px;
        color: #666;
        line-height: 30px;
        .text2-1 {
          color: #e50011;
        }
      }
      .pay-h-rbox {
        position: absolute;
        right: 0;
        top: 0;
        .text1 {
          font-size: 14px;
          color: #333;
          .text1-1 {
            font-size: 14px;
            color: #e50011;
            margin-right: 8px;
          }
          .text1-2 {
            font-size: 28px;
            color: #e50011;
          }
        }
        .text2 {
          font-size: 14px;
          color: #1480ff;
          text-align: right;
          .text2-2 {
            position: relative;
            display: inline-block;
            cursor: pointer;
            i {
              display: inline-block;
              transition: transform 0.3s;
            }
            &.active {
              i {
                transform: rotate(180deg);
              }
            }
          }
        }
      }
    }
    .order-detail {
      padding-top: 18px;
      margin-top: 26px;
      border-top: 1px solid #e0e0e0;
      .text3 {
        font-size: 14px;
        color: #333;
        line-height: 30px;
      }
    }
  }
  .pay-body {
    .pay-body-box {
      background: #fff;
      padding: 22px 40px 30px 40px;
      box-shadow: 0 0 29px rgba($color: #3e3031, $alpha: 0.2);
    }
    .pay-body-list {
      .item {
        padding: 23px 0;
        border-bottom: 1px dashed #e0e0e0;
        .text {
          display: inline-block;
          vertical-align: middle;
          font-size: 14px;
          color: #333;
          &.alt-label {
            width: 114px;
          }
        }
        .right-box {
          display: inline-block;
          vertical-align: middle;
          .text1 {
            font-size: 14px;
            color: #333;
            &.alt-red {
              color: #e50011;
            }
          }
          .btn {
            position: relative;
            display: inline-block;
            vertical-align: middle;
            width: 117px;
            height: 36px;
            line-height: 36px;
            text-align: center;
            font-size: 14px;
            color: #333;
            border: 1px solid #a8a8a8;
            margin-right: 15px;
            cursor: pointer;
            &::before {
              content: '';
              position: absolute;
              right: 0;
              top: 0;
              background: url('../../assets/img/zkj-order-select.png') no-repeat
                center center;
              background-size: cover;
            }
            &.active {
              border: 2px solid #e50011;
              &::before {
                width: 14px;
                height: 14px;
              }
            }
          }
        }
      }
    }
    .pay-submit {
      margin-top: 30px;
      text-align: center;
      .btn {
        display: inline-block;
        width: 152px;
        height: 42px;
        line-height: 42px;
        text-align: center;
        font-size: 14px;
        color: #fff;
        background: #e50011;
        cursor: pointer;
      }
    }
  }
}
.pay-bread {
  padding: 12px 0;
  a {
    font-size: 14px;
    color: #666;
    &.active {
      color: #e50011;
    }
  }
}

.pay-modal {
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 2000;
  .pay-shadow {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    background: rgba($color: #fff, $alpha: 0.9);
  }
  .pay-modal-body {
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    text-align: center;
    .pay-body_imgbox {
      width: 256px;
      height: 256px;
      margin: auto;
      border: 1px solid #eee;
      .pay-body_canvas {
        display: block;
        width: 100% !important;
        height: 100% !important;
      }
    }
    .pay-body_box {
      display: inline-block;
      vertical-align: middle;
      position: relative;
      z-index: 1000;
    }
    &::after {
      content: '';
      display: inline-block;
      width: 0;
      height: 100%;
      vertical-align: middle;
    }
    .pay-body_text {
      font-size: 14px;
      text-align: center;
      line-height: 40px;
      color: #e50011;
    }
  }
}
</style>
